module.exports = __webpack_public_path__ + "assets/end.aac254e8.svg";